module.exports = __webpack_public_path__ + "media/images/icon__predict-ae9b650d8a73651b5d27276e87688364.png";